import * as React from 'react';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputItem from './input-item';

const initialValue = {
  name: '',
  unit: '',
};
export const EvaluationCriteria = ({
  name,
  value,
  label = '',
  onChange,
  error = false,
  helperText = '',
  showCheckCriteria = false,
}) => {
  const [values, setValues] = React.useState([initialValue]);
  const initRef = React.useRef(true);
  const onAdd = () => {
    setValues((prev) => {
      let tmp = [...prev];
      tmp.push({ name: '', unit: '' });
      return tmp;
    });
  };
  const onDelete = (index) => {
    setValues((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });
  };
  React.useEffect(() => {
    if (initRef.current && value?.length) {
      setValues(value);
      initRef.current = false;
    }
  }, [value]);
  React.useEffect(() => {
    onChange &&
      onChange({
        persist: () => {},
        target: {
          type: 'change',
          name,
          value: values,
        },
      });
  }, [values]);
  const renderItems = (item, index) => {
    return (
      <InputItem
        showCheckCriteria={showCheckCriteria}
        key={'input-EvaluationCriteria-' + index}
        item={item}
        index={index}
        onAdd={onAdd}
        onDelete={onDelete}
        values={values}
        setValues={setValues}
        error={error}
      />
    );
  };
  return (
    <FormGroup margin="dense">
      <FormLabel>{label}</FormLabel>
      {values.map((item, index) => renderItems(item, index))}
      <FormHelperText error={error}>
        {helperText && 'Vui lòng nhập tiêu chí đánh giá'}
      </FormHelperText>
    </FormGroup>
  );
};
